import { Injectable, inject } from '@angular/core';
import { from, Observable, tap } from 'rxjs';
import Parse from 'parse';
import { Store } from '@ngxs/store';

import { LogoutUser, SetCurrentUser } from '@stores/user/user.actions';

import { LoggerService } from './logger.service';

@Injectable({
  providedIn: 'root',
})
export class UserService {
  private logger = inject(LoggerService);
  private store = inject(Store);

  constructor() {}

  initialize(): void {
    // This allows using Parse.User.current() in the Angular environment
    Parse.User.enableUnsafeCurrentUser();

    const user = Parse.User.current();
    if (user && user.authenticated()) {
      Parse.User.become(user.getSessionToken())
        .then((validUser) => {
          this.store.dispatch(new SetCurrentUser(user));
        })
        .catch((error) => {
          this.store.dispatch(new SetCurrentUser(null));
        });
    } else {
      this.store.dispatch(new SetCurrentUser(null));
    }
  }

  loginEmail(email: string, password: string): Observable<Parse.User> {
    return from(Parse.User.logIn(email, password)).pipe(
      tap((user) => {
        this.setUserACLs();
        this.store.dispatch(new SetCurrentUser(user));
      })
    );
  }

  logout() {
    this.store.dispatch(new LogoutUser());
    return from(Parse.User.logOut());
  }

  forgot(email: string) {
    return from(Parse.User.requestPasswordReset(email));
  }

  async setUserACLs() {
    const user = Parse.User.current();
    if (user && user.authenticated()) {
      await Parse.Cloud.run('setUserACLs');
    }
  }
}
